export default "__VITE_ASSET__DM41nE9S__"